<template>
  <div class="filter__date">
    <div class="filter__date-block">
      <input :class="['filter__date-input', 'js-datepicker-from-'+id]" type="text" placeholder="c" :name="'date_'+id+'_start'">
    </div>
    <div class="filter__date-block">
      <input :class="['filter__date-input', 'js-datepicker-to-'+id]" type="text" placeholder="по" :name="'date_'+id+'_end'">
    </div>
  </div>
</template>

<script>
export default {
  props: ["id", "dateStart", "dateEnd"],
  methods: {
    datePickerInit: function(el) {
      var fromEl = $(".js-datepicker-from-" + el);
      var toEl = $(".js-datepicker-to-" + el);

      var datepickerFromData = fromEl.datepicker().data("datepicker");
      var datepickerToData = toEl.datepicker().data("datepicker");

      fromEl.datepicker({
        onSelect: function() {
          var selectedDate = datepickerFromData.selectedDates[0];
          datepickerToData.update({
            minDate: new Date(selectedDate)
          });
        }
      });
      toEl.datepicker({
        onSelect: function() {
          var selectedDate = datepickerToData.selectedDates[0];
          datepickerFromData.update({
            maxDate: new Date(selectedDate)
          });
        }
      });
    },
    datePickerSetDate: function(el, type, date) {
      var el = $(".js-datepicker-" + type + "-" + el);
      var datepickerData = el.datepicker().data("datepicker");
      var pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
      datepickerData.selectDate(new Date(date.replace(pattern, "$3-$2-$1")));
    }
  },
  mounted() {
    var datepicker = this.id;
    if (this.dateStart)
      this.datePickerSetDate(datepicker, "from", this.dateStart);
    if (this.dateEnd) this.datePickerSetDate(datepicker, "to", this.dateEnd);
    this.datePickerInit(datepicker);
  }
};
</script>